/*
 * @Author: Gaho
 * @Date: 2023-12-22 17:03:50
 * @LastEditors: Gaho
 * @LastEditTime: 2024-07-25 11:28:18
 */
import { defineStore } from 'pinia';
export const usePlinkoStore = defineStore('plinko', {
    state: () => ({
        toggle: false,
        mutil: null,
        canBet: true, // 是否可以下注
        stageHasBall: false, // 是否有小球掉落
        onBetHistory: [] // 暂存下注记录
    }),
    actions: {
        setState(state){
            this.toggle = state;
        },
    }
})
